<template>
  <div>
    <PostLoginHeader v-if="showHeader === undefined" />
    <div class="d-flex justify-content-center col-12 h-75 " style="min-height: 50vh">
      <div class="d-flex card p-0 mt-5 flex-column">
        <div class="d-flex justify-content-between w-100 align-items-center">
          <div v-if="setupIntent !== null">
            <button class="btn btn-primary mr-5" @click="setupIntent = null">
              <span class="fs-5"> <i class="fa fa-arrow-left"></i> Back</span>
              <!-- <span class="fs-4">Back</span> -->
            </button>
          </div>
          
          <div v-else></div>
          <div>
            <h1 class="fs-1 fw-bold" v-if="subscriptionStatus == 'Expired Subscription'">
              Your
              <span v-if="JWTUser?.Subscriber?.StripeId !== null">Subscription</span>
              <span v-else>Trial Period</span> Has Expired
            </h1>
            <h1 v-else-if="!setupIntent" class="fs-1 fw-bold">Select your plan</h1>
            <h1 v-else-if="setupIntent !== null && paymentRate != 39.95" class="fs-1 fw-bold">
              Enter Shipping and Payment Information
            </h1>
            <h1 v-else-if="setupIntent !== null && paymentRate === 39.95" class="fs-1 fw-bold">
              Enter Payment Information
            </h1>
          </div>
          <div></div>
        </div>
        <div class="card-body d-flex flex-column align-items-center " v-if="JWTUser?.Subscriber?.SubscriptionType == 2 && !setupIntent">
          <p class="fs-3 my-5">
            All subscriptions come with a complimentary 7 day free trial, and you can
            cancel at any time.
          </p>
          <div class="d-flex justify-content-evenly w-100 flex-wrap mb-5">

            <div class="col-12 col-lg-6 mb-5">
              <div class="card border border-radius-1">
                <div class="modal-header d-flex justify-content-center">
                  <h1 class="fs-3 fw-bold" style="text-align: center">CrimeTime Monthly</h1>
                </div>
                <div class="card-body d-flex flex-column  justify-content-between fs-4 h-90 ">
                  <div class="d-flex flex-column justify-content-between align-items-cen p-5 h-100">
                    <div class="d-flex flex-column  mb-5">
                      <h1 class="fw-bold fs-2 ta-c">
                        $39.95/<span class="fs-5">month</span>
                        <span class="d-block fs-6 fw-normal">plus applicable sales tax</span>
                      </h1>
                      
                      
                      <ul class="mx-auto text-start fs-4">
                        <li><i class="fs-5 fa fa-check mr-3" style="color: green"></i>Unlimited PDF Case Reports</li>
                        <li><i class="fs-5 fa fa-check mr-3" style="color: green"></i>Crime Search Lookup Tool</li>
                        <li><i class="fs-5 fa fa-check mr-3" style="color: green"></i>Custody Credits Calculator</li>
                        <li><i class="fs-5 fa fa-check mr-3" style="color: green"></i>Dedicated Customer Support</li>
                        <li>
                          <i class="fs-5 fa fa-x mr-4" style="color: red"></i>Free Crimes Listing Booklet
                        </li>
                      </ul>
                    </div>
                    
                    <div class="ta-c"><button class="btn btn-xl btn-primary mt-3"  @click="selectPrice('monthly')">
                      Get Monthly
                    </button></div>
                  </div>
                  <!-- <div class="d-flex flex-column align-items-center"></div> -->

                  
                </div>
               
              </div>
            </div>

            <div class="col-12 col-lg-6 mb-5">
              <div class="card border border-radius-1">
                <div class="modal-header d-flex justify-content-center px-0">
                  <h1 class="fs-3 fw-bold" >CrimeTime Annual</h1>
                </div>
                <div class="card-body d-flex flex-column justify-content-between fs-4 h-90 pb-5">
                  <div class="d-flex flex-column justify-content-between align-items-cen h-100">
                    <div class="d-flex flex-column  p-5 ">
                      <h1 class="fw-bold fs-2  ta-c">
                        <span class="strikeout pr-3">$479.40</span>$395.00/<span class="fs-5">year</span>
                        <span class="d-block fs-6 fw-normal">plus applicable sales tax</span>
                      </h1>
                      
                      
                      <ul class="mx-auto text-start fs-4">
                        <li><i class="fs-5 fa fa-check mr-3" style="color: green"></i>Everything in CrimeTime Monthly</li>
                        <li><i class="fs-5 fa fa-check mr-3" style="color: green"></i>Save $84.40 annually</li>
                        <!-- <li><i class="fs-5 fa fa-check mr-3" style="color: green"></i>Priority access to new features</li> -->
  
                        <li>
                          <i class="fs-5 fa fa-check mr-3" style="color: green"></i>Free Crimes Listing Booklet
                        </li>
  
                      </ul>
                    </div>
                    
                    <div class="ta-c"><button class="btn btn-xl btn-primary "  @click="selectPrice('yearly')">
                      Get Annual
                    </button></div>
                  </div>
                  <!-- <div class="d-flex flex-column align-items-center"></div> -->

                  
                </div>
              </div>
            </div>
            <!-- <div class="col-12 col-lg-4">
              <div class=`card fancy-card p-0`>
                <div class="card-header">
                  <h1 class="fs-2 fw-bold">Organization License</h1>
                </div>
                <div
                  class="card-body d-flex flex-column align-items-center justify-content-between fs-4"
                >
                  <div class="d-flex flex-column align-items-center w-100">
                    <h1 class="fw-bold fs-2 mb-5">Contact us for Pricing</h1>
                    <p class="fs-5">County and Government agencies are eligible for bulk discounts on multiple licenses.</p>
                    
                  </div>

                  
                  <div class="d-flex flex-column align-items-center">
                    <a href="https://placergroup.com/contact" target="_blank">
                      <button class="btn btn-xl btn-primary">Contact Us</button>
                    </a>
                  </div>
                </div>
              </div>
            </div> -->
          </div>
          <div class="d-flex flex-column align-items-center mt-3" v-if="paymentRate !== null">
            <p class="fs-4 mb-5">
              You pay: <span class="fw-bold">${{ paymentRate?.toFixed(2) }}</span> plus applicable sales tax on
              {{ createMomentInAWeek(new Date()) }}, billed
              {{ paymentRate === 39.95 ? "monthly" : "annually" }}
            </p>
            <button class="btn btn-xl btn-primary" style="scale: 1.3" @click="selectPaymentMethod('card')">
              Continue
            </button>
          </div>
        </div>
        <StripeCard v-else-if="setupIntent !== null" class="mx-auto col-12 p-0" @error="errorHandle" :quantity="1" :price="paymentRate" :setupIntent="setupIntent" :errorProp="error"></StripeCard>
        <div class="card-body p-5 text-align-center" v-else>
          <p class="fs-6" style="font-weight: 400">
            In order to continue using CrimeTime, please reach out to CrimeTime support via email at <br />
            support@placergroup.com
          </p>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import moment from "moment";
import PostLoginHeader from "./PostLoginHeader.vue";
import StripeCard from "./StripeCard.vue";
import axios from "axios";
export default {
  name: "CreateSubscription",
  components: { PostLoginHeader, StripeCard },
  props: ["showHeader"],
  data() {
    return {
      subscriptionStatus: null,
      JWTUser: null,
      setupIntent: null,
      error: null,
      paymentRate: null,
      isSingleCountyUser: false,
    };
  },
  methods: {
    createMomentInAWeek(date) {
      return moment(date).add(7, "days").format("MM/DD/YYYY");
    },
    selectPrice(rate) {
      if (rate === "monthly") {
        this.paymentRate = 39.95;
        // console.log(this.paymentRate)
      } else {
        this.paymentRate = 395;
        // console.log(this.paymentRate)
      }
    },
    async selectPaymentMethod(paymentMethod) {
      // console.log('Calling createSubscription with', this.paymentRate, this.JWTUser, paymentMethod)
      // console.log('JWTUser', this.JWTUser)
      this.paymentMethod = paymentMethod;
      const setupIntentId = await axios
        .post(
          process.env.VUE_APP_ENDPOINT + "/api/stripesubscription/createSubscription",
          {
            price: this.paymentRate,
            user: this.JWTUser,
            paymentMethod: this.paymentMethod,
          },
          {
            headers: { Authorization: `Bearer ` + localStorage.getItem("user_token") },
          }
        )
        .then((data) => {
          this.setupIntent = data?.data?.setupIntent;
          this.orderComplete = true;
        });
    },
    errorHandle(err) {
      if (err.message?.length > 0) {
        this.error = err.message;
      } else {
        this.error = err;
      }
    },
  },
  async beforeMount() {
    this.subscriptionStatus = localStorage.getItem("subscription_status");
    this.JWTUser = JSON.parse(localStorage.getItem("user_attr"));
    // console.log(this.JWTUser);
    if (!this.JWTUser) {
      const JWTUser = await axios.post(process.env.VUE_APP_ENDPOINT + "/api/auth/checkcredentials", {
        user_token: localStorage.getItem("user_token"),
      }, {
        headers: { Authorization: `Bearer ` + localStorage.getItem("user_token") },
      }).then((data) => {
        return data.data;
      }).catch((e) => {
        console.error(e);
        if (e.status == 402 && e?.response?.data?.authorized)  { 
          localStorage.setItem("user_token", e?.response?.data?.token);
          localStorage.setItem("user_attr", JSON.stringify(e?.response?.data?.user_attr));
          localStorage.setItem("subscription_status", e?.response?.data?.subscriptionStatus);
          return e?.response?.data?.user_attr;
        }
        return null;
      });
      // console.log(JWTUser);
      this.JWTUser = JWTUser;
    }
  },
};
</script>
<style scoped>



.fancy-card {
  border-radius: 10px;
  box-shadow: 0 0 10px 0 rgba(0, 0, 0, 0.2);
  /* Add margin to provide spacing */
}

.fancy-card > .card-header {
  border-top-left-radius: 10px;
  border-top-right-radius: 10px;
}

.fancy-card > .card-body {
  border-bottom-left-radius: 10px;
  border-bottom-right-radius: 10px;
}



.strikeout {
  text-decoration: line-through;
  font-weight: 300;
}

.card {
  height: 100% !important;
}

li {
  list-style-type: none;
}

.h-90 {
  height: 90%;
}
</style>
